export default __webpack_public_path__ + "static/media/twitter.ee51e6f4.png";